
import { Route, Routes } from 'react-router-dom'
import Branches from "../client_pages/branches_page/Branches";
import Categories from "../client_pages/categories_page/Categories"
import Jobs from "../client_pages/jobs_page/Jobs"
import HelpDesk from "../client_pages/helpdesk_page/HelpDesk"
import Payment from "../client_pages/payment_page/Payment"
import ProductPage from "../client_pages/product_page/ProductPage"
import Home from '../client_pages/home_page/Home';
import Signup from "../client_pages/sign_pages/Signup";
import Dashboard from '../dashboard/pages/Dashboard';
import NotFound404 from '../NotFound404';
import ClientPage from '../ClientPage';
import Signin from '../client_pages/sign_pages/Signin';
import SignForm from '../client_pages/sign_pages/SignForm';
import AboutPage from '../client_pages/about_page/AboutPage';
import ProfilePage from '../client_pages/profile_page/ProfilePage';
import { useContext } from 'react';
import { AppContext } from '../../contextApi/ContextApi';

export default function ClientRoutes({website}) {
    const {currentUserUID} = useContext(AppContext);

    if(!website || !website.settings || !website.settings.domain)return <NotFound404/>
    return (
        // an early implementation of react v7
        <Routes>
            {/* Client pages */}
            <Route path={`/${website?.settings?.domain}/`}>
                <Route index element={<ClientPage child={<Home website={website} isDashboard={false}/>}/>}/>
                <Route path='*' element={<NotFound404/>}/>
            </Route>
            <Route path={`/${website?.settings?.domain}/home`} element={<ClientPage child={<Home website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/products`} element={<ClientPage child={<Categories website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/products/:name`} element={<ClientPage child={<ProductPage website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/our_branches`} element={<ClientPage child={<Branches website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/our_jobs`} element={<ClientPage child={<Jobs website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/helpdesk`} element={<ClientPage child={<HelpDesk website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/about`} element={<ClientPage child={<AboutPage website={website} isDashboard={false}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/${currentUserUID}/profile/`} element={<ClientPage child={<ProfilePage/>}/>}/>
            <Route path={`/${website?.settings?.domain}/payment`} element={<ClientPage child={<Payment website={website}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/signup`} element={<ClientPage child={<SignForm childForm={<Signup website={website} _minWidth={600} _height={66}/>} header={"הצטרף אלינו עכשיו - "} isClient={true}/>}/>}/>
            <Route path={`/${website?.settings?.domain}/signin`} element={<ClientPage child={<SignForm childForm={<Signin website={website} _minWidth={400} _height={60}/>} header={"התחבר עכשיו - "} isClient={true}/>}/>}/>
    
            {/* Dashboard and not found exception */}
            <Route path={`/${website?.settings?.domain}/${website?.owner?.uid}/dashboard`} element={<Dashboard website={website}/>}/>
            <Route path={`/*`} element={<NotFound404/>}/>
        </Routes>
    )
}
